<template>
    <ul 
        v-if="menus.length" 
        class="sidebar-menu"
    >
        <li>
            <b-link
                to="/area_cliente/inicio"
            >
                <i 
                    class="mr-1 fa fa-dashboard"
                /> 
                Início
            </b-link>
        </li>
        <li 
            v-for="(menu, i) in menus"
            :key="i"
        >
            <b-link
                :to="menu.url"
            >
                <i 
                    class="mr-1"
                    :class="menu.icone"
                /> 
                {{ menu.nome }}
            </b-link>
        </li>
        <li>
            <b-link
                @click="$store.state['usuarios'].modalAlterarSenha = !$store.state['usuarios'].modalAlterarSenha"
            >
                <i 
                    class="mr-1 fa fa-key"
                /> 
                Alterar senha
            </b-link>
        </li>
        <li>
            <b-link
                @click="logout" 
            >
                <i 
                    class="mr-1 fa fa-power-off"
                /> 
                Sair
            </b-link>
        </li>
    </ul>
</template>
<script>
import { mapActions } from 'vuex'
export default {
    data(){
        return {
            menus: [],
            servicos: {
                'OS': {
                    nome: 'Ordens de Serviços',
                    icone: 'fa icon-websitebuilder',
                    url: '/area_cliente/ordens_servicos'
                },
                'PE': {
                    nome: 'Pedidos',
                    icone: 'fa icon-shopping',
                    url: '/area_cliente/pedidos'
                },
                'BO': {
                    nome: 'Cobranças',
                    icone: 'fa fa-money',
                    url: '/area_cliente/movimentacoes_financeiras'
                },
                'SR': {
                    nome: 'Assinaturas',
                    icone: 'fa fa-refresh',
                    url: '/area_cliente/servicos_recorrentes'
                },
                'AT': {
                    nome: 'Chamados',
                    icone: 'fa fa-phone',
                    url: '/area_cliente/chamados'
                },
                'NF': {
                    nome: 'NF-e',
                    icone: 'fa  fa-shopping-cart',
                    url: '/area_cliente/notas_fiscais'
                },
                'NFS': {
                    nome: 'NFS-e',
                    icone: 'fa fa-file-text-o',
                    url: '/area_cliente/notas_fiscais_servicos'
                },
                'NFC': {
                    nome: 'NFC-e',
                    icone: 'fa fa-qrcode',
                    url: '/area_cliente/notas_fiscais_consumidores'
                }
            }
        }
    },
    mounted() {
        const habilitados = this.$usuarioLogado.webdesk_servicos.split(':')
        for (const chave of Object.keys(this.servicos)) {
            if (habilitados.includes(chave)) {
                this.menus.push(this.servicos[chave])
            }
        }
    },
    methods:{
        ...mapActions('usuarios', {
            xLogout: 'logout'
        }),
        async logout(){
            this.$loading.show()
            const logout = await this.xLogout()
            if(logout.status == 'success'){
                location.href = this.$urlBase + '/login'
            }else{
                this.$loading.hide()
                this.$dialog.error(logout.message)
            }
        }
    }
}
</script>